<template>
  <div class="survey-view-detail">
    <dl class="dl-horizontal" v-if="hasRefrigerator">
      <dt>Fabricante</dt>   <dd>{{ survey.data.refrigerator.manufacturer }}</dd>
      <dt>Anos de uso</dt>    <dd>{{ survey.data.refrigerator.yearsUse }}</dd>
      <dt>Número de série</dt>    <dd>{{ survey.data.refrigerator.sealingNumber }}</dd>
      <dt>Nota</dt>     <dd>{{ survey.data.refrigerator.score }}</dd>
      <dt>Carcaça</dt>    <dd>{{ survey.data.refrigerator.body }}</dd>
      <dt>Serpentina</dt>    <dd>{{ survey.data.refrigerator.coil }}</dd>
      <dt>Compartimentos</dt>    <dd>{{ survey.data.refrigerator.compartments }}</dd>
      <dt>Portas</dt>    <dd>{{ survey.data.refrigerator.doors }}</dd>
      <dt>Motor</dt>    <dd>{{ survey.data.refrigerator.engine }}</dd>
      <dt>Borracha</dt>    <dd>{{ survey.data.refrigerator.rubber }}</dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'survey-view-detail',

  props: ['survey'],

  computed: {
    hasData () {
      return this.survey.hasOwnProperty('data')
    },

    hasRefrigerator () {
      return this.hasData && this.survey.data.hasOwnProperty('refrigerator')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyViewDetail.vue